import contract from '@mailobj-browser/front/js/contracts/contract.js'
import actionsBar from './actionsBar/actionsBar.js'
import animations from './animations/animations.js'
import chip from './chip/chip.js'
import childHideable from './childHideable/childHideable.js'
import clickToCopy from './clickToCopy/clickToCopy.js'
import collapse from './collapse/collapse.js'
import color from './color/color.js'
import completion from './completion/completion.js'
import control from './control/control.js'
import date from './date/date.js'
import datetime from './datetime/datetime.js'
import elementCounter from './elementCounter/elementCounter.js'
import field from './field/field.js'
import fieldset from './fieldset/fieldset.js'
import fieldsCollection from './fieldsCollection/fieldsCollection.js'
import help from './help/help.js'
import hotkey from './hotkey/hotkey.js'
import launcher from './launcher/launcher.js'
import library from './library/library.js'
import list from './list/list.js'
import menu from './menu/menu.js'
import meta from './meta/meta.js'
import modal from './modal/modal.js'
import nav from './nav/nav.js'
import password from './password/password.js'
import print from './print/print.js'
import profile from './profile/profile.js'
import sidebar from './sidebar/sidebar.js'
import tree from './tree/tree.js'
import range from './range/range.js'
import rte from './rte/rte.js'
import scroll from './scroll/scroll.js'
import select from './select/select.js'
import workers from './workers/workers.js'
/* @todo AJAX
import anchor from '#utilities/js/fetchers/anchor.js'
import form from '#utilities/js/fetchers/form.js'
import main from '#utilities/js/switchers/main.js'
import meta from '#utilities/js/switchers/meta.js'
import title from '#utilities/js/switchers/title.js'
*/
import selectors from './selectors/selectors.js'
import table from './table/table.js'
import tabs from './tabs/tabs.js'
import targeting from './targeting/targeting.js'
import timeSelect from './timeSelect/timeSelect.js'
import upload from './upload/upload.js'
import xaddrs from './xaddrs/xaddrs.js'
import xfiles from './xfiles/xfiles.js'

export default contract({
  ...selectors,
  animations,
  actionsBar,
  childHideable,
  chip,
  clickToCopy,
  tree,
  collapse,
  color,
  completion,
  control,
  date,
  datetime,
  elementCounter,
  field,
  fieldset,
  fieldsCollection,
  help,
  hotkey,
  launcher,
  library,
  list,
  menu,
  meta,
  modal,
  nav,
  profile,
  scroll,
  select,
  table,
  tabs,
  targeting,
  timeSelect,
  password,
  print,
  range,
  rte,
  sidebar,
  upload,
  workers,
  xaddrs,
  xfiles
})
